(function(){
  var css=[
    'label.jb-card{border:1.5px solid #E0DDD8!important;border-radius:4px!important;background-color:#F8F5F0!important;cursor:pointer!important;position:relative!important;transition:border-color .25s ease,background-color .25s ease!important;overflow:visible!important;padding-bottom:44px!important;}',
    '.jb-grid input[type=checkbox],.jb-wrap input[type=checkbox],.jb-card input[type=checkbox]{display:block!important;position:absolute!important;overflow:hidden!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important}',
    '.jb-tick{display:none!important}',
    'label.jb-card.is-checked,label.jb-card.jonis-picked,label.jb-card.jb-card--active,label.jb-card.active,label.jb-card.checked{border-color:#72d580!important;background-color:rgba(114,213,128,.06)!important}',
    '.jonis-toggle{position:absolute!important;bottom:10px!important;left:50%!important;transform:translateX(-50%)!important;width:42px!important;height:24px!important;background:#ccc!important;border-radius:12px!important;transition:background .25s ease!important;display:block!important;}',
    '.jonis-toggle::after{content:""!important;position:absolute!important;top:3px!important;left:3px!important;width:18px!important;height:18px!important;background:#fff!important;border-radius:50%!important;transition:left .25s ease!important;box-shadow:0 1px 4px rgba(0,0,0,.25)!important;display:block!important;}',
    'label.jb-card.is-checked .jonis-toggle,label.jb-card.jonis-picked .jonis-toggle,label.jb-card.jb-card--active .jonis-toggle,label.jb-card.active .jonis-toggle,label.jb-card.checked .jonis-toggle{background:#72d580!important;}',
    'label.jb-card input[type=checkbox]:focus-visible~.jonis-toggle{outline:2px solid #5C5757!important;outline-offset:4px!important;}',
    'label.jb-card.is-checked .jonis-toggle::after,label.jb-card.jonis-picked .jonis-toggle::after,label.jb-card.jb-card--active .jonis-toggle::after,label.jb-card.active .jonis-toggle::after,label.jb-card.checked .jonis-toggle::after{left:21px!important;}'
  ].join('');

  var style=document.createElement('style');
  style.textContent=css;
  document.head.appendChild(style);

  function addToggle(card){
    if(card.querySelector('.jonis-toggle'))return;
    var t=document.createElement('span');
    t.className='jonis-toggle';
    card.appendChild(t);
  }

  function initJbCards(){
    var cards=document.querySelectorAll('label.jb-card');
    if(!cards.length)return;
    cards.forEach(function(card){
      addToggle(card);
      if(card._jonisInit)return;
      card._jonisInit=true;
      var cb=document.getElementById(card.htmlFor)||card.querySelector('input[type="checkbox"]');
      if(cb&&cb.checked)card.classList.add('jonis-picked');
      card.addEventListener('click',function(){
        setTimeout(function(){
          var cb2=document.getElementById(card.htmlFor)||card.querySelector('input[type="checkbox"]');
          if(cb2&&cb2.checked){card.classList.add('jonis-picked');}
          else{card.classList.remove('jonis-picked');}
        },80);
      });
    });
  }

  document.addEventListener('DOMContentLoaded',initJbCards);
  setTimeout(initJbCards,400);
  setTimeout(initJbCards,1200);
  new MutationObserver(function(m){
    m.forEach(function(x){
      x.addedNodes.forEach(function(n){
        if(n.nodeType===1&&((n.matches&&n.matches('label.jb-card'))||(n.querySelector&&n.querySelector('label.jb-card')))){
          setTimeout(initJbCards,100);
        }
      });
    });
  }).observe(document.body,{childList:true,subtree:true});
})();
